import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators'

@Module({ name: 'User', namespaced: true, stateFactory: true })
export default class User extends VuexModule {
  public token: string = '' || localStorage.getItem('User_token')
  public userInfo: any = null || (localStorage.getItem('User_userInfo') && JSON.parse(localStorage.getItem('User_userInfo')))

  // 用户模块：
  @Mutation
  public setTokenForUser (token: string) {
    this.token = token
    localStorage.setItem('User_token', this.token)
  }

  @Mutation
  public setUserInfoForUser (userInfo: any) {
    this.userInfo = userInfo
    localStorage.setItem('User_userInfo', JSON.stringify(this.userInfo))
  }

  @Mutation
  public removeTokenForUser () {
    this.token = ''
    localStorage.removeItem('User_token')
  }

  @Mutation
  public removeUserInfoForUser () {
    this.userInfo = null
    localStorage.removeItem('User_userInfo')
  }
}
